import { memo } from 'react';
import styles from './reviewButton.module.css';
export default memo(function ReviewButton({ onClick, disabled }) {
  return <button className={styles.SubmitBtn} onClick={onClick} disabled={disabled}>Submit Review</button>;
})
